import React, { useEffect, useState } from "react"
import { Col, Row, Table, Form, Container } from "react-bootstrap"
import { useNavigate, useParams, useLocation } from "react-router-dom"
import Modal from "antd/es/modal/Modal"
import noDataImg from "../../../../Assets/Images/no-data-img.png"
import {
  getCurrentDateTimeYYMMDDHHMMSS,
  dateFormat,
  getName,
  numberFormat,
  refreshPage,
  toastStyle,
  TokenExpiry,
} from "../../../../Helpers/Utils/Common"
import toast from "react-hot-toast"
import ElmhurstLogo from "../../../../Assets/Images/elmhurst-initial-logo.png"
import cleanLogo from "../../../../Assets/Images/Login/transparent_bg.png"
import signature from "../../../../Assets/Images/signature.png"
import Navbar from "../../../../Components/Navbar/Navbar"
import SEModal from "./SEModal"
import PaymentTable from "../../../Sales/PaymentTable"
import Moment from "moment"
import {
  approveSuppliesExpense,
  getSingleSuppliesExpense,
  emailSE,
  emailSalesExpense,
} from "../../../../Helpers/apiCalls/Purchases/suppliesExpensesApi"
import { getSupplier } from "../../../../Helpers/apiCalls/suppliersApi"
import Footer from "../../../../Components/Footer/Footer"
import html2canvas from "html2canvas"
import jsPDF from "jspdf"
import SalesModal from "../../../SalesModules/Component/SalesModal"
import AttachmentModal from "../../../../Components/AttachmentModal/AttachmentModal"

export default function PrintSuppliesExpense() {
  const { id } = useParams()
  let navigate = useNavigate()
  const { state } = useLocation()
  const [inactive, setInactive] = useState(true)
  const [printSE, setPrintSE] = useState([])
  const [items, setItems] = useState([])
  const [note, setNote] = useState("")
  const [hasEmail, setHasEmail] = useState(false)
  const [paymentInfo, setPaymentInfo] = useState([])
  const [showSendModal, setShowSendModal] = useState(false)
  const handleShowSendModal = () => setShowSendModal(true)
  const handleCloseSendModal = () => setShowSendModal(false)
  const [fileList, setFileList] = useState([])
  const [preview, setPreview] = useState(false)
  const [previewFile, setPreviewFile] = useState("")
  const [prepBySignature, setPrepBySignature] = useState()
  const [apprBySignature, setApprBySignature] = useState()
  const [isClicked, setIsClicked] = useState(false)
  const [startAt, setStartAt] = useState(0)
  /* Attachments Modal */
  const [showAttachmentsModal, setShowAttachmentsModal] = useState(false)
  const handleShowAttachmentsModal = () => setShowAttachmentsModal(true)
  const handleCloseAttachmentsModal = () => setShowAttachmentsModal(false)

  async function fetchSE() {
    setPrintSE({})
    setItems([])

    const response = await getSingleSuppliesExpense(id)
    if (response.error) {
      TokenExpiry(response)
    } else {
      var SE = response.data.data[0]
      setFileList(SE.supplies_expense_attachments)
      // SE.invoice_no = SE.invoice_no[0].invoice_no;
      SE.hasSupplier = SE.supplier_trade_name ? true : false
      setPrintSE(SE)
      setItems(SE.supplies_expense_items)

      var payment = SE.supplies_expense_payments?.map((data) => {
        var info = data
        info.payment_date = Moment(data.payment_date).format("MMM DD, YYYY")
        info.type = data.payment_mode
        info.details =
          data.payment_mode === "check"
            ? data.payment_mode + " - " + data.check_no
            : data.payment_mode === "bank"
            ? data.payment_mode + " - " + data.reference_no
            : data.payment_mode === "others"
            ? data.type
              ? data.reference_no
                ? data.type + " - " + data.reference_no
                : data.type
              : data.reference_no
            : data.payment_mode
        info.amount = data.total_payment
          ? numberFormat(data.total_payment)
          : "0.00"
        info.amount_applied_to_invoice = data.amount_applied_to_invoice
          ? numberFormat(data.amount_applied_to_invoice)
          : "0.00"
        return info
      })
      setPaymentInfo(payment)
    }
  }

  /* print modal handler */
  const [showPrintModal, setShowPrintModal] = useState(false)
  const handleShowPrintModal = () => setShowPrintModal(true)
  const handleClosePrintModal = () => setShowPrintModal(false)

  async function handleSendToSupplier() {
    if (printSE.supplier_email || printSE.vendor_email) {
      const response = await emailSE(id)

      if (response.response) {
        toast.success(response.response.message, {
          style: toastStyle(),
        })
        setTimeout(() => {
          navigate("/suppliesexpenses", {
            params: {
              state: "sent",
            },
          })
        }, 1000)
      } else {
        toast.error("Email not sent", {
          style: toastStyle(),
        })
        setTimeout(() => {
          setIsClicked(false)
          handleCloseSendModal()
        }, 1000)
      }
    } else {
      toast.error("Error sending email. Supplier has no email!", {
        style: toastStyle(),
      })
      setTimeout(() => {
        setIsClicked(false)
        handleCloseSendModal()
      }, 1000)
    }
  }

  function handleClickImageThumbnail(index) {
    handleShowAttachmentsModal()
    setStartAt(index)
  }

  const handleSendEmail = async (ref) => {
    if (ref) {
      const element = document.getElementById(ref)
      setIsClicked(true)

      html2canvas(element).then(async (canvas) => {
        const imgData = canvas.toDataURL("image/jpeg", 0.7) // Adjust the quality here (0.7 is just an example)
        const pdf = new jsPDF()
        const pdfWidth = pdf.internal.pageSize.getWidth()
        const pdfHeight = pdf.internal.pageSize.getHeight()
        const imgWidth = canvas.width
        const imgHeight = canvas.height
        const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight)
        const imgX = (pdfWidth - imgWidth * ratio) / 2
        const imgY = 5
        pdf.addImage(
          imgData,
          "JPEG",
          imgX,
          imgY,
          imgWidth * ratio,
          imgHeight * ratio
        )

        // Convert the pdf file from Blob to File obj (needed for upload API)
        var blobPdf = pdf.output("blob")

        const dateToday = getCurrentDateTimeYYMMDDHHMMSS()
        const formPdf = new File(
          [blobPdf],
          `Supplies_Expenses_${dateToday}.pdf`,
          {
            type: blobPdf.type,
          }
        )

        console.log(formPdf)

        // if (printPO.supplier_email || printPO.vendor_email) {
        const response = await emailSalesExpense(id, formPdf)

        if (response.response) {
          toast.success(response.response.message, {
            style: toastStyle(),
          })
          setTimeout(() => {
            navigate("/suppliesexpenses", {
              params: {
                state: "sent",
              },
            })
          }, 1000)
        } else {
          setIsClicked(false)
          toast.error("Email not sent", {
            style: toastStyle(),
          })
          setTimeout(() => {
            setIsClicked(false)
            handleCloseSendModal()
          }, 1000)
        }
        // }
      })
    }
  }

  convertFromHtmlToImage()

  async function convertFromHtmlToImage() {
    const preparedBySignatureLink = printSE.prepared_by_name_signature
    const approvedBySignatureLink = printSE.approved_by_name_signature
    try {
      const prepByBase64Data = await imageUrlToBase64(preparedBySignatureLink)
      setPrepBySignature(prepByBase64Data)

      const apprByBase64Data = await imageUrlToBase64(approvedBySignatureLink)
      setApprBySignature(apprByBase64Data)
    } catch {}
  }

  async function handlePrintSE() {
    toast.loading("Printing Supplies Expense", {
      style: toastStyle(),
    })
    handleClosePrintModal()
    setTimeout(() => {
      toast.dismiss()
      Print()
    }, 1000)
  }

  async function imageUrlToBase64(url) {
    try {
      const response = await fetch(url)
      const blob = await response.blob()
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onloadend = () => resolve(reader.result)
        reader.onerror = reject
        reader.readAsDataURL(blob)
      })
    } catch (error) {
      return null
    }
  }

  async function fetchSupplierData() {
    const response = await getSupplier(state?.suppID)
    if (response.response) {
      setHasEmail(
        response.response.data[0].email !== null &&
          response.response.data[0].email !== "null" &&
          response.response.data[0].email !== ""
      )
    }
  }

  useEffect(() => {
    convertFromHtmlToImage()
  })

  useEffect(() => {
    fetchSupplierData()
  })

  function renderTable() {
    return (
      <Table>
        <thead>
          <tr>
            <th></th>
            {/* <th>Item Code</th> */}
            <th>Item Name</th>
            <th>U o M</th>
            {/* <th>Size</th> */}
            <th>Quantity</th>
            {/* <th>Discount</th> */}
            <th>Price/Unit</th>
            <th>Amount</th>
            <th>Remarks</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item, index) => {
            return (
              <tr key={index} className="req-table-w-border-bottom">
                <td className="req-table-w-border-sides">{index + 1}</td>
                {/* <td className="req-table-w-border-sides">{item.item_code}</td> */}
                <td className="req-table-w-border-sides">{item.name}</td>
                <td className="req-table-w-border-sides">{item.unit}</td>
                {/* <td className="req-table-w-border-sides">{item.item_size}</td> */}
                <td className="req-table-w-border-sides">
                  {parseInt(item.qty)}
                </td>
                {/* <td className="req-table-w-border-sides">{numberFormat(item.discount_amount)} ({parseFloat(item.discount_percentage).toFixed(0)}%)</td> */}
                <td className="req-table-w-border-sides">
                  {numberFormat(item.price)}
                </td>
                <td className="req-table-w-border-sides">
                  {numberFormat(item.total)}
                </td>
                <td className="req-table-w-border-sides">{item.remarks}</td>
              </tr>
            )
          })}
        </tbody>
      </Table>
    )
  }

  function Print() {
    let printContents = document.getElementById("printablediv").innerHTML
    let originalContents = document.body.innerHTML
    document.body.innerHTML = printContents
    window.print(printContents)
    document.body.innerHTML = originalContents
    setTimeout(() => {
      refreshPage()
    }, 1000)
  }

  React.useEffect(() => {
    fetchSE()
  }, [])

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive)
          }}
          active={"SUPPLIES"}
        />
      </div>
      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        <div className="print-container px-3 py-2" id="printablediv">
          <div className="print-header-elm d-flex flex-column flex-sm-row">
            <div className="w-full">
              <div className="print-top d-flex justify-content-start py-1">
                <img src={ElmhurstLogo} className="print-logo-elm" alt="" />
              </div>
              <div className="print-top">
                {/* <h1 className="print-shop-header d-flex justify-content-start">ELMHURST ENTERPRISES</h1> */}
                <h5 className="print-shop-header-elm d-flex justify-content-start print-data">
                  497 D MOLAVE EXTENSION, LAHUG, CEBU CITY
                </h5>
                {/* <h5 className="print-shop-header-elm d-flex justify-content-start">San Roque, Cebu City</h5> */}
              </div>
            </div>
            <div className="purchase-order-number-print-container w-full">
              <h1 className="purchase-order-title-print-elm">EXPENSE ORDER</h1>
              <div className="po-date-elm">
                <div className="po-date-and-number">
                  <h5 className="print-shop-header-elm d-flex justify-content-end print-data">
                    PO DATE: {dateFormat(printSE.supplies_expense_date)}
                  </h5>
                  <h5 className="print-shop-header-elm d-flex justify-content-end print-data">
                    {" "}
                    P.O NO.: {printSE.id}
                  </h5>
                </div>
              </div>
            </div>
          </div>

          <div className="supplier-address-container my-5">
            {/* <h2 className="supplier-title-elm">Supplier</h2> */}
            <h4 className="print-shop-header-elm supplier-name-elm d-flex justify-content-start print-data fs-5">
              SUPPLIER:{" "}
              {printSE.supplier_trade_name ||
                printSE.vendor_trade_name ||
                "N/A"}
            </h4>
            <h5 className="print-shop-header-elm d-flex justify-content-start print-data">
              Delivery Address: {printSE.delivery_address}
            </h5>
          </div>

          {/* content */}
          <div className="mt-5">
            <Row className="mt-5">
              <Col md={5} className="ms-2">
                {/* <div className="d-flex my-2 align-items-center ms-5">
                                    <Col xs={4} className="print-label">
                                        Supplier:
                                    </Col>
                                    <Col xs={6} className="print-data">
                                        {printSE.supplier_trade_name ||
                                            printSE.vendor_trade_name ||
                                            "N/A"}
                                    </Col>
                                </div> */}
                <div className="d-flex my-2 align-items-center">
                  <Col xs={3} className="print-label">
                    Branch:
                  </Col>
                  <Col xs={5} className="print-data">
                    {printSE.branch_name}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={3} className="print-label">
                    Forwarder:
                  </Col>
                  <Col xs={5} className="print-data">
                    {printSE.forwarder_name}
                  </Col>
                </div>
                {/* <div className="d-flex my-2 align-items-center ms-5">
                                    <Col xs={3} className="print-label">
                                        Delivery Address:
                                    </Col>
                                    <Col xs={6} className="print-data">
                                        {printSE.delivery_address}
                                    </Col>
                                </div> */}
              </Col>

              <Col md={5} className="ms-2">
                <div className="d-flex my-2 align-items-center">
                  <Col xs={3} className="print-label">
                    Invoice No.:
                  </Col>
                  <Col xs={5} className="print-data">
                    {printSE.invoice_no}
                  </Col>
                </div>
                {/* <div className="d-flex my-2 align-items-center">
                                    <Col xs={3} className="print-label">
                                        Purchase Date:
                                    </Col>
                                    <Col xs={6} className="print-data">
                                        {dateFormat(
                                            printSE.supplies_expense_date
                                        )}
                                    </Col>
                                </div> */}
                <div className="d-flex my-2 align-items-center">
                  <Col xs={3} className="print-label">
                    Requisitioner:
                  </Col>
                  <Col xs={5} className="print-data">
                    {printSE.requisitioner_name}
                  </Col>
                </div>
                {/* <div className="d-flex my-2 align-items-center">
                                    <Col xs={3} className="print-label">
                                        {" "}
                                    </Col>
                                    <Col xs={6} className="print-data"></Col>
                                </div> */}
              </Col>
            </Row>
            <div className="d-flex mt-1 mb-2 justify-content-evenly">
              {/* table */}
              <div className="print-table mt-3 mx-2">{renderTable()}</div>
            </div>
            <Row className="mt-2">
              <span className="print-footer">{printSE.remarks}</span>
            </Row>
            {/* <div className="d-flex justify-content-end mt-4 mx-5">
                            <div className="print-table-footer-label bold grand-label mx-4">
                                GRAND TOTAL
                                <span className="mx-2 print-table-footer-data grand-label">
                                    PHP {numberFormat(printSE.grand_total)}
                                </span>
                            </div>
                        </div> */}
            <Row className="align-right bold pt-3 pe-5">
              <Col xs={2} className="text-end">
                <span className="edit-label color-gray print-data">
                  Grand Total
                </span>
              </Col>
              {/* <Col xs={1} className="text-end">
                                <span className="edit-label color-gray print-data">PHP</span>
                            </Col> */}
              <Col xs={3} className="text-end">
                <span className="edit-label color-gray print-data">
                  {printSE.grand_total
                    ? numberFormat(printSE.grand_total)
                    : "0.00"}
                </span>
              </Col>
            </Row>

            {/* <Row className="mt-4">
                            <span className="print-footer">
                                {printSE.remarks}
                            </span>
                        </Row> */}
            {/* <Row className="mt-4 additional-note-input">
                            <Col xs={7}>
                                <div className="d-flex my-2 align-items-center">
                                    <Col
                                        xs={4}
                                        className="print-label"
                                        style={{
                                            color: "var(--primary-color)",
                                            fontFamily: "Gotham-Rounded-Medium",
                                        }}
                                    >
                                        Additional Note:{" "}
                                    </Col>
                                    <Col xs={6} className="print-data">
                                        <Form.Control
                                            size="sm"
                                            type="text"
                                            name="additional note"
                                            className="nc-modal-custom-input"
                                            value={note}
                                            onChange={(e) =>
                                                setNote(e.target.value)
                                            }
                                            required
                                        />
                                    </Col>
                                </div>
                            </Col>
                        </Row> */}
            <div className="mt-5 mb-5 ">
              <Row className="d-flex flex-column flex-sm-row gap-3 gap-sm-0">
                <Col xs={6} className="print-sig">
                  <div className="justify-content-center d-flex flex-column align-items-center">
                    {/* {printSE.prepared_by_name}
                    <div className="margin-underline"></div>
                    Prepared by */}
                    <img
                      // src={printSE.prepared_by_name_signature}
                      src={prepBySignature}
                      className="print-logo signature-size"
                      alt=""
                    />
                    <p className="print-data underline-border text-center">
                      {printSE.prepared_by_name}
                    </p>
                    <p className="print-data text-center mt-2">Prepared by</p>
                  </div>
                </Col>
                <Col xs={6} className="print-sig">
                  <div className="justify-content-center d-flex flex-column align-items-center">
                    {/* {printSE.prepared_by_name}
                    <div className="margin-underline"></div>
                    Prepared by */}
                    <img
                      // src={printSE.approved_by_name_signature}
                      src={apprBySignature}
                      className="print-logo"
                      alt=""
                    />
                    <p className="print-data underline-border text-center">
                      {printSE.approved_by_name}
                    </p>
                    <p className="print-data text-center mt-2">Approved by</p>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </div>
        <div className="mt-4 noPrint mx-3">
          <Row className="review-data mb-2">FILE ATTACHMENTS</Row>
          {/* <Row className="">
            {fileList &&
              fileList.map((attachment) => (
                <Col
                  xs={1}
                  onClick={() => {
                    setPreviewFile(attachment.file_url)
                    setPreview(true)
                  }}
                  className="cursor-pointer preview-container"
                >
                  <img
                    src={attachment.file_url}
                    className="img-preview"
                    alt=""
                  />
                </Col>
              ))}
            {(!fileList || fileList.length === 0) && (
              <Col xs={1}>
                <div className="no-data-cont d-flex justify-content-left preview-container">
                  <img
                    src={noDataImg}
                    alt="no data found"
                    className="img-preview"
                  />
                </div>
              </Col>
            )}
          </Row> */}
          <div className="d-flex flex-row gap-2 overflow-auto">
            {fileList &&
              fileList.map((attachment, index) => (
                <div key={index} className="thumbnail-cont">
                  <img
                    src={attachment.file_url}
                    className="image-thumbnail"
                    alt=""
                    onClick={() => handleClickImageThumbnail(index)}
                  />
                </div>
              ))}
            {!fileList ||
              (fileList.length === 0 && (
                <div>
                  <div className="no-data-cont d-flex justify-content-left preview-container">
                    <img
                      src={noDataImg}
                      alt="no data found"
                      className="img-preview"
                    />
                  </div>
                </div>
              ))}
          </div>
        </div>

        {printSE.status === "sent" && (
          <>
            <Container
              fluid
              className="PI-payment-info-wrapper mt-5 py-3 px-3 edit-form"
            >
              <h5 className="PI-payment-info">PAYMENT HISTORY</h5>
              <div className="justify-content-center">
                <PaymentTable
                  tableHeaders={[
                    "PAYMENT DATE",
                    "TYPE",
                    "DETAILS",
                    "PAYMENT AMOUNT",
                    "AMOUNT APPLIED TO INV",
                  ]}
                  headerSelector={[
                    "payment_date",
                    "type",
                    "details",
                    "amount",
                    "amount_applied_to_invoice",
                  ]}
                  tableData={paymentInfo}
                />
              </div>
            </Container>
          </>
        )}

        {/* footer */}
        <div className="d-flex justify-content-end my-4 mb-5 d-flex-responsive">
          <button
            className="button-secondary me-3"
            onClick={() => navigate("/suppliesexpenses")}
          >
            Close
          </button>
          <button
            className="button-tertiary me-3"
            onClick={handleShowSendModal}
          >
            Send to Supplier
          </button>
          <button className="button-primary" onClick={handleShowPrintModal}>
            Print
          </button>
        </div>
      </div>
      {/* modals */}
      <SEModal
        show={showPrintModal}
        hide={handleClosePrintModal}
        type="print"
        handler={handlePrintSE}
      />

      <SalesModal
        show={showSendModal}
        hide={handleCloseSendModal}
        message="Are you sure you want to send this expense order to the supplier?"
        handler={() => handleSendEmail("printablediv")}
        isClicked={isClicked}
      />
      <Modal
        open={preview}
        title={""}
        footer={null}
        onCancel={() => setPreview(false)}
      >
        <img
          alt="example"
          style={{
            width: "100%",
          }}
          src={previewFile}
        />
      </Modal>
      <AttachmentModal
        show={showAttachmentsModal}
        images={fileList}
        onHide={() => handleCloseAttachmentsModal()}
        selected={startAt}
      />
      <Footer />
    </div>
  )
}
